import type { AppLanguage } from '../i18n/languages'

const DISPLAY_NAMES: Record<string, Partial<Record<AppLanguage, string>>> = {
  Butter: { de: 'Butter', fr: 'Beurre', en: 'Butter' },
  'Olive Oil': { de: 'Olivenöl', fr: 'Huile d\'olive', en: 'Olive Oil' },
  'Chicken Breast': { de: 'Hähnchenbrust', fr: 'Blanc de poulet', en: 'Chicken Breast' },
  Eggs: { de: 'Eier', fr: 'Œufs', en: 'Eggs' },
  Rice: { de: 'Reis', fr: 'Riz', en: 'Rice' },
  Oats: { de: 'Haferflocken', fr: 'Flocons d\'avoine', en: 'Oats' },
  Spinach: { de: 'Spinat', fr: 'Épinards', en: 'Spinach' },
  Broccoli: { de: 'Broccoli', fr: 'Brocoli', en: 'Broccoli' },
  'Greek Yogurt': { de: 'Griechischer Joghurt', fr: 'Yaourt grec', en: 'Greek Yogurt' },
  'Sweet Potato': { de: 'Süßkartoffel', fr: 'Patate douce', en: 'Sweet Potato' },
  Salmon: { de: 'Lachs', fr: 'Saumon', en: 'Salmon' },
  Avocado: { de: 'Avocado', fr: 'Avocat', en: 'Avocado' },
  Banana: { de: 'Banane', fr: 'Banane', en: 'Banana' },
  Cheese: { de: 'Käse', fr: 'Fromage', en: 'Cheese' },
  'Ground Beef': { de: 'Rinderhack', fr: 'Bœuf haché', en: 'Ground Beef' },
  Tofu: { de: 'Tofu', fr: 'Tofu', en: 'Tofu' },
  Lentils: { de: 'Linsen', fr: 'Lentilles', en: 'Lentils' },
  Chickpeas: { de: 'Kichererbsen', fr: 'Pois chiches', en: 'Chickpeas' },
  'Peanut Butter': { de: 'Erdnussbutter', fr: 'Beurre de cacahuète', en: 'Peanut Butter' },
  'Almond Butter': { de: 'Mandelmus', fr: 'Beurre d\'amande', en: 'Almond Butter' },
}

export function localizeIngredientName(canonicalName: string, language: AppLanguage): string {
  return DISPLAY_NAMES[canonicalName]?.[language] ?? canonicalName
}
